function newClass(element: HTMLElement, data: string): void {
    element.className = data;
}

// ----------------------------------------------------------------------------

export default newClass;
